import type { ReactElement } from "react";
import { Optionen } from "@kundeninfo/ui/me-design";

/**
 * Eine Wahl als Segmente, für Leiste, Zeitraum und Kachelwahl. `short`: sichtbarer Kurztext je Wert (`data-kurz`, me-design C8), der volle
 * Text bleibt Name und Sofort-Popup; ein Kurztext gleich dem vollen entfällt.
 */
export function Segments<V extends string>(p: {
  name: string; value: V; options: readonly (readonly [V, string])[]; short?: Readonly<Partial<Record<V, string>>>; locked?: boolean;
  onChoice: (v: V) => void;
}): ReactElement {
  const kurz = (value: V, text: string): { "data-kurz"?: string } => {
    const k = p.short?.[value];
    return k === undefined || k === text ? {} : { "data-kurz": k };
  };
  return (
    <Optionen aria-label={p.name} darstellung="segmente" richtung="waagerecht" wert={p.value} gesperrt={p.locked === true}
      onGeaendert={(d) => { p.onChoice(d.wert as V); }}>
      {p.options.map(([value, text]) => <option key={value} value={value} {...kurz(value, text)}>{text}</option>)}
    </Optionen>
  );
}

/** Die Einträge einer Texttabelle als Segmente: Ihre Folge ist die der Oberfläche. */
export const pairs = <K extends string>(o: Readonly<Record<K, string>>): (readonly [K, string])[] => Object.entries(o) as [K, string][];
